module.exports = __webpack_public_path__ + "static/media/rome2.4cb53a0c.jpeg";